import React from 'react';
import {
  Flex,
  IconButton,
  Divider,
  Button,
  Text
} from '@chakra-ui/react';
import { FiZoomIn, FiZoomOut, FiMaximize2 } from 'react-icons/fi';

export default function FlowToolbar({ 
  showGrid, 
  setShowGrid, 
  onZoomIn, 
  onZoomOut, 
  onFitView,
  currentZoom = 100 
}) {
  return (
    <Flex
      bg="white"
      borderBottom="1px"
      borderColor="gray.200"
      px={6}
      py={2}
      align="center"
      gap={2}
    >
      <IconButton 
        size="sm" 
        variant="ghost" 
        icon={<FiZoomIn />}
        onClick={onZoomIn}
        aria-label="Zoom in"
      />
      <Text fontSize="sm" fontWeight="medium" minW="45px" textAlign="center">
        {currentZoom}%
      </Text>
      <IconButton 
        size="sm" 
        variant="ghost" 
        icon={<FiZoomOut />}
        onClick={onZoomOut}
        aria-label="Zoom out"
      />
      <Divider orientation="vertical" h={5} />
      <Button 
        size="sm" 
        variant="ghost" 
        leftIcon={<FiMaximize2 />}
        onClick={onFitView}
      >
        Fit to Screen
      </Button>
      {/* <Divider orientation="vertical" h={5} />
      <HStack spacing={2}>
        <FiGrid />
        <Switch 
          size="sm" 
          isChecked={showGrid} 
          onChange={(e) => setShowGrid(e.target.checked)} 
        />
      </HStack> */}
    </Flex>
  );
}